<!-- https://xd.adobe.com/view/5a99e1ec-5384-4360-a0f7-d32f2e012228-0fca/specs/ -->
<!-- https://docs.google.com/presentation/d/1d_O6nM_jbVWXj20W_5KjxkR_8fwRXV3JKD3D4bXYOqM/edit#slide=id.g13a94655b6d_0_0 -->
<!-- https://docs.google.com/document/d/1JOy1cSFY-KGBVHjjZMcWkEtaLlliAzMHHh6ceHp8gBo/edit -->
<template>
  <div id="Reviewspage" class="clearfix">
    <div class="col-12 px0">
      <div v-if="reviewslength">
        <div class="clearfix p3 my3 lightgrey-background flex justify-start items-center">
          <p class="h5 darkblue mb0 line-height-golden">Ingen anbefalinger</p>
        </div>
      </div>
    </div>
    <div class="flex col-12 p0" v-if="totalitems > 0">
      <el-pagination class="p0 my2" background layout="prev, pager, next" :page-size="perPage" @current-change="paginationChanged" :total="this.totalitems">
      </el-pagination>
      <div @click="filterReviews = true" class="flex justify-center items-center ml-auto">
        <span class="pointer">Filter</span>
        <span class="mx2 pointer">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="29" viewBox="0 0 32 29">
            <path id="Icon_feather-filter" data-name="Icon feather-filter" d="M33,4.5H3L15,18.69V28.5l6,3V18.69Z" transform="translate(-2 -3.5)" fill="none" stroke="#707070" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          </svg>
        </span>
      </div>
    </div>
    <div class="col-12 px0" v-if="loading">
      <div >
        <div class="loader"></div>
      </div>
    </div>
    <div class="col-12 flex flex-wrap px0" v-if="reviews !== 0 && !loading">
      <div :id="'row-' + review.ID" :class="'col-12 mr2 mb2 border muted-border shadow p2 ' + review.STATUS" v-for="review in reviewsbitrix" :key="review.ID">
        <div class="flex mt1 justify-start items-center">
          <div class="col-4 blur-part p0">
            <image-rating v-model="review.RATING" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="22" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
          </div>
          <div class="col-6 ml-auto flex justify-end p0 gap-10">
          <!-- v-if="review.AssignmentDistributedCount === 1" -->
            <span  class="green">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -1.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-shield-check-f"><path d='M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z' /></svg>
            </span>
            <!-- <span v-else class="mediumgrey">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -1.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-shield-check-f"><path d='M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z' /></svg>
            </span> -->
            <span><i class="el-icon-setting h4"></i></span>
          </div>
        </div>
        <div class="flex flex-column justify-center mb2">
          <div class="flex items-center">
            <div class="p0 col-2">
              <p class="h5 darkblue semi-bold line-height-golden m0">{{ review.CONTACT.NAME }}</p>
            </div>
            <span class="px2">|</span>
            <div class="col-4 p0">
              <p class="darkblue semi-bold line-height-golden m0"> {{ review.BRANCH }}</p>
            </div>
          </div>
          <div class="p0">
              <p class="h6 darkblue mb0 relative">{{ moment(review.DATE).format('LL') }}</p>
            </div>
        </div>
        <div class="blur-part clearfix flex justify-between xs-flex-column gap-10">
          <div class="sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12 p0 m0">
            <button href="javascript:void(0)" class="block buttonanbefal m0 outlined-primary-button col-12  p1 not-rounded gibson h5 flex justify-center items-center pointer no-hover" @click="showItemDetails(review)">
              <span class="relative mr1">
                <svg fill="currentColor" height="36" viewBox="0 -75 512 512" width="36" xmlns="http://www.w3.org/2000/svg"><path d="m446.019531 300.152344h-38c-5.519531 0-10-4.476563-10-10v-26.960938c0-6.78125-5.511719-12.292968-12.292969-12.292968h-6.53125v20.785156c0 7.183594-4.578124 13.527344-11.398437 15.789062-6.816406 2.253906-14.28125-.09375-18.570313-5.855468l-36.867187-49.503907c-4.960937-6.664062-4.960937-15.96875 0-22.628906l36.871094-49.507813c4.285156-5.757812 11.75-8.109374 18.566406-5.851562 6.820313 2.257812 11.398437 8.605469 11.398437 15.785156v22.984375h12.355469c35.550781 0 64.472657 28.921875 64.472657 64.472657v32.78125c-.003907 5.527343-4.480469 10.003906-10.003907 10.003906zm-28-20h18v-22.785156c0-24.519532-19.949219-44.46875-44.46875-44.46875h-18.929687c-7.402344 0-13.425782-6.023438-13.425782-13.429688v-19.394531l-30.328124 40.722656 30.328124 40.722656v-17.195312c0-7.402344 6.023438-13.425781 13.425782-13.425781h13.105468c17.808594 0 32.292969 14.484374 32.292969 32.292968zm0 0"/><path d="m66.105469 153.820312c-5.523438 0-10 4.480469-10 10 0 5.523438 4.476562 10 10 10h.023437c5.523438 0 9.988282-4.476562 9.988282-10 0-5.519531-4.488282-10-10.011719-10zm0 0"/><path d="m385.480469 108.523438c-3.675781 0-7.320313.15625-10.917969.46875v-67.351563c0-11.679687-4.835938-22.25-12.605469-29.820313-.121093-.125-.246093-.253906-.375-.375-7.773437-7.378906-17.953125-11.445312-28.660156-11.445312h-291.28125c-10.710937 0-20.886719 4.066406-28.664063 11.445312-.128906.125-.253906.25-.375.375-7.769531 7.570313-12.601562 18.140626-12.601562 29.820313v161.761719c0 10.492187 3.902344 20.089844 10.328125 27.417968.144531.183594.292969.363282.453125.539063 2.96875 3.273437 6.414062 6.023437 10.183594 8.175781 6.09375 3.503906 13.152344 5.507813 20.675781 5.507813h217.714844c5.113281 65.105469 59.730469 116.519531 126.125 116.519531 69.761719-.003906 126.519531-56.757812 126.519531-126.519531s-56.757812-126.519531-126.519531-126.519531zm-132.148438-13.785157-49.570312 43.707031c-4.699219 4.144532-10.589844 6.214844-16.480469 6.214844-4.511719 0-9.019531-1.210937-12.996094-3.640625-.242187-.148437-.484375-.300781-.722656-.460937-.402344-.261719-.792969-.539063-1.179688-.828125-.539062-.402344-1.070312-.832031-1.582031-1.285157l-49.570312-43.707031c-.003907 0-.003907 0-.003907 0l-84.203124-74.242187c1.488281-.324219 3.03125-.496094 4.617187-.496094h291.28125c1.582031 0 3.128906.171875 4.613281.496094l-84.164062 74.207031c-.011719.015625-.027344.023437-.039063.035156zm99.65625-61.203125c1.015625 2.503906 1.574219 5.242188 1.574219 8.105469v70.6875c-19.84375 4.96875-37.648438 14.519531-52.363281 27.386719l-28.542969-36.230469zm-311.648437 191.503906c-.015625 0-.03125 0-.042969 0-.085937 0-.171875-.003906-.257813-.003906-.015624 0-.027343-.003906-.046874-.003906-3.039063-.089844-6.003907-.824219-8.707032-2.121094l15.621094-19.824218c3.417969-4.339844 2.671875-10.625-1.667969-14.046876-4.335937-3.414062-10.625-2.667968-14.042969 1.667969l-12.039062 15.285157c-.101562-.847657-.15625-1.710938-.15625-2.589844v-161.761719c0-2.863281.558594-5.601563 1.574219-8.105469l79.332031 69.949219-16.78125 21.300781c-3.417969 4.339844-2.671875 10.625 1.667969 14.042969 4.339843 3.417969 10.625 2.675781 14.042969-1.664063l16.09375-20.433593 41.644531 36.71875c14.6875 12.949219 35.851562 14.667969 52.261719 5.152343 2.507812-1.453124 4.90625-3.171874 7.152343-5.152343l41.644531-36.71875 29.488282 37.433593c-6.953125 8.382813-12.832032 17.660157-17.445313 27.617188-.019531.039062-.035156.078125-.054687.117188-.03125.074218-.066406.144531-.101563.21875-6.195312 13.441406-9.992187 27.941406-11.164062 42.921874h-217.714844c-.101563.003907-.199219 0-.300781 0zm344.140625 116.519532c-58.734375 0-106.519531-47.78125-106.519531-106.519532 0-.214843.003906-.429687.003906-.644531 0-.070312 0-.144531 0-.214843.003906-.148438.003906-.292969.003906-.441407.003906-.070312.003906-.140625.003906-.210937 0-.011719 0-.019532 0-.027344.003906-.140625.003906-.285156.007813-.425781 0-.066407.003906-.136719.003906-.203125 0-.011719 0-.023438 0-.039063.003906-.136719.007813-.273437.007813-.410156.003906-.0625.003906-.121094.007812-.183594 0-.027343 0-.058593 0-.085937.003906-.136719.007812-.277344.011719-.417969.003906-.035156.003906-.074219.003906-.109375 0-.046875.003906-.089844.003906-.136719.003907-.160156.011719-.320312.015625-.480469 0-.007812.003906-.019531.003906-.027343 0-.042969 0-.085938.003907-.132813.007812-.191406.015625-.382812.023437-.574218 0-.015626 0-.035157.003906-.050782 2.527344-56.507812 49.289063-101.699218 106.410157-101.699218 58.734375 0 106.519531 47.78125 106.519531 106.515624 0 58.738282-47.785156 106.519532-106.519531 106.519532zm0 0"/></svg>
              </span>
              <span class="h6 semi-bold mb0 line-height-1 pl1">Læs og besvar</span>
            </button>
          </div>
          <div class="sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12 p0 m0">
            <button type="button" class="block buttonanbefal outlined-dark-button p1 col-12  flex justify-center items-center gibson not-rounded pointer" @click="downloadreview(review,0)">
              <span class="relative mr1">
                <svg fill="currentColor" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M406 187.5c-1.1-78.1-64.9-141.2-143.2-141.2 -34.8 0-68.4 12.7-94.5 35.7 -23.3 20.5-39.2 48-45.5 78.1 -0.5 0-0.9 0-1.4 0C54.4 160 0 214.4 0 281.3s54.4 121.3 121.3 121.3h44.5c6 0 10.9-4.9 10.9-10.9 0-6-4.9-10.9-10.9-10.9H121.3c-54.9 0-99.5-44.6-99.5-99.5s44.6-99.5 99.5-99.5c2.9 0 6 0.2 9.4 0.5 5.8 0.5 11-3.6 11.8-9.4 3.9-28.8 18.2-55.3 40.1-74.6 22.1-19.5 50.5-30.2 80.1-30.2 66.9 0 121.4 54.5 121.4 121.4 0 2.4-0.4 8.6-0.4 8.6 -0.2 3.2 1 6.4 3.3 8.6 2.3 2.2 5.5 3.3 8.7 3 2.9-0.3 5.8-0.4 8.7-0.4 47.3 0 85.8 38.5 85.8 85.8 0 47.3-38.5 85.8-85.8 85.8h-48.9c-6 0-10.9 4.9-10.9 10.9s4.9 10.9 10.9 10.9h48.9c59.3 0 107.6-48.3 107.6-107.6C512 236.3 464.6 188.3 406 187.5z"/><path d="M262.8 97.5c-45.7 0-84.7 34.1-90.9 79.4 -0.8 6 3.4 11.5 9.3 12.3 6.4 0.9 11.5-3.9 12.3-9.3 4.7-34.5 34.5-60.5 69.3-60.5 6 0 10.9-4.9 10.9-10.9C273.7 102.4 268.8 97.5 262.8 97.5z"/><path d="M313.3 410.3c-4-4.5-10.9-4.9-15.4-0.9l-26.3 23.5V298.5c0-6-4.9-10.9-10.9-10.9 -6 0-10.9 4.9-10.9 10.9v134.3l-26.3-23.5c-4.5-4-11.4-3.6-15.4 0.9 -4 4.5-3.6 11.4 0.9 15.4l39.7 35.5c3.4 3.1 7.7 4.6 12 4.6 4.3 0 8.6-1.5 12-4.6l39.7-35.5C316.9 421.7 317.3 414.8 313.3 410.3z"/></svg>
              </span>
              <span class="h6 semi-bold mb0 line-height-1 " style="color: currentColor;">Gem billede af anbefalingen</span>
            </button>
          </div>
          <div class="sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12 p0 m0">
            <button type="button" class="buttonanbefal p0 outlined-facebook-button p1 col-12  pointer no-hover flex justify-center items-center " @click="downloadreview(review,1)">
              <span class="mr1 relative">
                <img src="/static/svg/facebook.svg" alt="" width="20" height="20">
              </span>
              <span class="h6 semi-bold mb0 left-align ">Del anbefaling på Facebook</span>
            </button>
          </div>
          <div class="sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12 p0 m0">
            <button type="button" :class="' flex justify-center buttonanbefal pointer report-facebook-button col-12 p0 items-center flag flag-link' + review.ID" title="Rapporter anbefaling" @click="showReportForm(review.ID)" v-if="review.STAGE != 'Pending'">
            <img src="/static/svg/feather-flag.svg" class="mr2" alt="" width="20" height="20">
            Rapporter anbefaling
            </button>
          </div>
        </div>
        <div class="col-8 mx-auto py1">
          <b-form v-model="reportForm" :class="'hide report-form report-form' + review.ID">
            <b-form-select v-model="report" :options="reportOptions" class="col-12 mb2" @change="reportOptionsChanged(review)"></b-form-select>
            <b-form-select v-model="industryValue" :options="prisenJoboption" v-if="fileUploadVisible" class="col-12 mb2" ></b-form-select>
            <b-form-textarea id="textarea" v-model="reportNote" placeholder="Skriv evt. kommentar" class="mb2" ></b-form-textarea>
            <!-- <file-upload-input token="" module="" @UpdateTilbud="handleFileUpload" v-if="fileUploadVisible"></file-upload-input> -->
            
            <!-- <span class="p3"><i class="h3 el-icon-plus darkblue"></i></span> -->
            <el-upload class="col-12 p0 mb2" action="#" v-if="fileUploadVisible"
                :on-change="handleFileUpload"
                :auto-upload="false"
                accept=".jpg, .jpeg, .png, .webp, .pdf, .doc, .docx"
                :file-list="fileList"
                list-type="text"
                :limit="1"
                :multiple="false"
                :disabled="disable">
                <div class=" flex items-center justify-center " style="border: 3px dashed rgb(25, 163, 192);"  >
                    <span class=" relative">
                      Indsend dokumentation for opgavens reelle fagkategori
                    </span>
                </div>
            </el-upload>
            <button type="button" class="btn rounded action-button btn-lg col-12" @click="checkBeforeSubmit(review)" :disabled="isLoadingReview">
              Anmod om ændring
            </button>
          </b-form>
        </div>
      </div>
    </div>
    <b-modal v-model="reviewShow" ref="reviewModal" v-if="reviewShow">
      <div class="col-12 flex justify-end items-center px0 ">
        <button type="button" @click="reviewShow = false" class="white-background border-0 not-rounded">
          <span> <i class="el-icon-circle-close darkblue h5"></i> </span>
        </button>
      </div>
      <!-- header -->
      <div  class="clearfix px2 mb1">
        <div class="h5 darkblue semi-bold gibson pt2">
          Din kunde <strong>{{ sampleReview.RequesterName }}</strong> har givet dig følgende vurdering
        </div>
      </div>
      <div class="modal-content px2 gibson" style="border:0;">
        <!-- total -->
        <div class="flex justify-between items-center mt3 mb2">
          <span class="h5 semi-bold darkblue mb0">Samlet vurdering</span>
          <span>
            <image-rating v-model="sampleReview.total" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="20" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
          </span>
        </div>
        <!-- quality -->
        <div class="flex justify-between items-center mb2">
          <span class="h6 regular darkblue mb0">Leverer kvalitetsarbejde</span>
          <span>
            <image-rating v-model="sampleReview.quality" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="16" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
          </span>
        </div>

        <!-- bargain -->
        <div class="flex justify-between items-center mb2">
          <span class="h6 regular darkblue mb0">Overholder budgettet</span>
          <span>
            <image-rating v-model="sampleReview.bargain" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="16" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
          </span>
        </div>

        <!-- clean -->
        <div class="flex justify-between items-center mb2">
          <span class="h6 regular darkblue mb0">Rydder godt op efter sig</span>
          <span>
            <image-rating v-model="sampleReview.clean" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="16" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
          </span>
        </div>


        <!-- time -->
        <div class="flex justify-between items-center mb2">
          <span class="h6 regular darkblue mb0">Overholder aftaler</span>
          <span>
            <image-rating v-model="sampleReview.time" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="16" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
          </span>
        </div>

        <!-- listen -->
        <div class="flex justify-between items-center mb2">
          <span class="h6 regular darkblue mb0">Er god til at lytte til kunden</span>
          <span>
            <image-rating v-model="sampleReview.listen" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="16" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
          </span>
        </div>
        <!-- recommend -->
        <div class="flex justify-between items-center mb2">
          <span class="h6 regular gibson darkblue mb0">Vil du anbefale os</span>
          <span>
            <image-rating v-model="sampleReview.recommend" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="16" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
          </span>
        </div>
        <div class="my2">
          <div class="h6 darkblue semi-bold mb2 gibson">{{ sampleReview.Title }}</div>
          <div v-html="sampleReview.RequesterComment" class="darkblue line-height-1 h6 regular break-word"></div>
        </div>
        <!-- response -->
        <div class="flex flex-column">
          <div class="h6 darkblue semi-bold mb2 gibson">Kommentar</div>
          <textarea id="textarea1" v-model="sampleReview.SupplierComment" placeholder="Skriv en kommentar til anbefalingen her" :rows="4" :max-rows="6" class="darkblue lightgrey-background line-height-1 p2 h6 border-none not-rounded">
          </textarea>
        </div>
      </div>
      <!-- modalFooter -->
      <div slot="modal-footer" class="col-12 flex flex-column px0">
        <div class="col-12 px0 clearfix flex justify-between items-center gibson">
          <div class="col-6 pr1 pl0">
            <button type="button" slot="modal-cancel" class="col-12 p2 not-rounded outlined-disabled-button gibson h5 flex justify-center items-center" @click="hideModal">
              <span class="pr2">
                <i class="el-icon-back"></i>
              </span>
              <span class="h5 semi-bold mb0">Luk</span>
            </button>
          </div>
          <div class="col-6 px0">
            <button type="submit" slot="modal-ok" class="col-12 action-button p2 not-rounded gibson h5 line-height-1 flex justify-center items-center" @click="addeditcomment(sampleReview)" :disabled="isLoadingReview">
            <span class="h6 semi-bold mb0">Gem kommentar</span>
            <span class="pl2"><i class="el-icon-right"></i></span>
          </button>
          </div>
        </div>
        <div class="col col-6 pr1 mt1 mb4 pl0">
          <button type="button" class="col-12 hide outlined-action-button p2 gibson h5 line-height-1 not-rounded">
            <span class="h6 semi-bold mb0" @click="reviewcs_service()">Rappoter til Håndværker.dk</span>
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="reviewShowcs" ref="reviewShowcs">
      <div  class="clearfix px2 mb1">
        <div class="h6 darkblue semi-bold gibson pt2">
          Rapporter om <strong>{{ sampleReview.RequesterName }}</strong> som givet dig følgende vurdering . (Review ID: {{ sampleReview.ID }} )
        </div>
      </div>
      <div class="modal-content px2 gibson" style="border:0;">
        <textarea variant="secondary" id="textarea2" v-model="sampleReviewcs"   :rows="4" :max-rows="8" class="darkblue lightgrey-background line-height-golden" style="border:0;font-size:1rem;">
        </textarea>
      </div>
      <div slot="modal-footer" class="col-12 flex justify-between items-center gibson pt2 pb3">
        <button type="button" slot="modal-cancel" class="standard-button px2 py1" @click="hideModal">
              <span class="h6 semi-bold mb0">Luk</span>
        </button>
        <button type="submit" slot="modal-ok" class="action-button px2 py1" @click="reportreview(sampleReview)" :disabled="isLoadingReview">
          <span class="h6 semi-bold mb0">Rappoter</span>
        </button>
      </div>
    </b-modal>
    <b-modal hide-footer centered size="sm" v-model="filterReviews" id="filterReviews" ref="filterReviewsModal">
              <template v-slot:modal-title>
                <p class="h5 semi-bold darkblue gibson line-height-1 my2">
                  Filtrer
                </p>
              </template>
              <form action="">
                <div class="clearfix p2 mt2">
                  <div class="col-12 px0">
                    <p class="h6 darkblue semi-bold gibson mb2">Antal stjerner</p>
                  </div>
                  <el-radio-group v-model="ratingVal">
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <el-radio label="all" class="flex" value="all" style="width:18px;height:18px;outline:none;">
                    <span class="h5 px1">All</span>
                    </el-radio>  
                  </div>
                  <div class="col-12 px0 flex justify-start items-center mb2" v-for="(num,index) in 5" :key="index">
                    <el-radio :label="num" class="flex" :value="num" style="width:18px;height:18px;outline:none;">
                    <div class="px1">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="num" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="5" :read-only="true"></image-rating>
                    </div>
                    </el-radio>  
                  </div>
                  </el-radio-group>
                  <!-- unanswered -->
                  <!-- <div class="col-12 px0 flex justify-start items-center mt3 mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingNocomment" value="1" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2 relative" style="top:-3px;">
                      <p class="h6 semi-bold gibson darkblue mb0">
                        Ubesvaret anbefalinger
                      </p>
                    </div>
                  </div> -->
                </div>
              </form>
              <template v-slot:modal-footer>
                <div class="col-12 flex justify-center px0">
                  <button @click="hideModal" class="outlined-disabled-button h5 gibson not rounded line-height-1 flex justify-start p2 items-center">
                    <span class="mx1"><i class="el-icon-back"></i></span>
                    <span>Luk</span>
                  </button>
                </div>
              </template>
    </b-modal>
    <b-modal hide-footer size="lg" class="p3" ref="projectDescription" v-model="endprisenpopup" centered id="projectDescription"  title="Project description">
      <div class="col-12 flex justify-end items-center white-background px0 p2">
        <button type="button" class="white-button no-border not-rounded " @click="endprisenpopup = false">
          <span> <i class="el-icon-circle-close"></i> </span>
        </button>
      </div>
      <div class="flex flex-column justify-center items-center">
        <p class="my2 darkblue mx-auto">
          <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="#19A3C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        </p>
        <div class="py2 px3">
          <p class="line-height-golden h4 regular">Anbefalinger lavet i perioden fra 16/8/2022 til og med 15/8/2023, kan ikke rettes mere pga. <a href="https://www.haandvaerker.dk" class="pointer" target="_blank" type="button">Håndværker.dk</a> Prisen 2023</p>
        </div> 
      </div>
    </b-modal>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import StarRating from 'vue-star-rating'
import {ImageRating} from 'vue-rate-it'
import fileUploadInput from '../../components/file-upload-input'
export default {
  name: 'reviews',
  components: {
    StarRating,
    loading,
    Simplert,
    ImageRating,
    fileUploadInput
  },
  props: ['id', 'ratingNocomment', 'premonth'],
  data () {
    return {
      rating: 0,
      show: false,
      showMobile: false,
      loading: true,
      isLoadingReview: false,
      label: 'Loading...',
      sampleReviewcs: '',
      overlay: 1,
      reviews: [],
      reviewscat: [],
      reviewShow: false,
      reviewShowcs: false,
      reviewslength: false,
      text: '',
      industryValue: null,
      sampleReview: [],
      reportForm: '',
      report: null,
      reportOptions: [
        {
          value: null, text: 'Vælg indstilling', disabled: true
        },
        {
          value: '1', text: 'Jeg udførte ikke arbejdet'
        },
        {
          value: '2', text: 'Dårligt sprog'
        },
        {
          value: '5', text: 'Forkert antal stjerner'
        },
        {
          value: '3', text: 'Forkert kategori'
        },
        {
          value: '4', text: 'Andre grunde'
        }
      ],
      reportNote: '',
      fileUploadVisible: false,
      fileList: [],
      reviewsbitrix: [],
      haaId: '',
      salesPersonbitrix: '',
      salesPerson: '',
      totalitems: 0,
      lastpage: 1,
      perPage: 15,
      prisenJoboption: [],
      filterReviews: false,
      ratingVal: 'all',
      disable: false,
      endprisenpopup: false,
      openreportid: '',
      currentpage: 1
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width >= 1000) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
    this.haaId = localStorage.getItem('haaid')
    // this.Reload()
    this.getreviewsBitrix(1)
  },
  watch: {
    ratingVal: function (newValue, oldValue) {
      this.getreviewsBitrix(1, '', newValue)
    },
    ratingNocomment: function (newValue, oldValue) {
      console.log(newValue)
    }
  },
  computed: {
    getReviews () {
      var reviews = []
      this.reviews.filter(item => {
        if (this.ratingVal.length) {
          for (var id in this.ratingVal) {
            var val = this.ratingVal[id]
            if (Math.round(item.Rating) === parseInt(val)) {
              reviews.push(item)
            }
          }
        } else {
          reviews.push(item)
        }
      })
      var subreviews = []
      reviews.filter(item => {
        if (this.ratingNocomment) {
          if (item.SupplierCommentDate === null) {
            subreviews.push(item)
          }
        } else {
          subreviews.push(item)
        }
      })
      return subreviews.filter((e, i) => subreviews.indexOf(e) >= i)
    }
  },
  methods: {
    getreviewsBitrix (page, searchitem = '', ratingitem = '') {
      var searchdata = ''
      searchdata = searchitem !== '' ? '&search=' + searchitem : ''
      var ratedata = ''
      ratedata = ratingitem !== '' && ratingitem !== 'all' ? '&rating=' + ratingitem : ''
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/rating/reviews?page=' + page + '&size=' + this.perPage + searchdata + ratedata, { headers }, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          this.reviewsbitrix = res.data.items
          this.totalitems = res.data.total
          this.lastpage = res.data.last_page
          this.loading = false
          if (this.prisenJoboption.length < 1) {
            this.gettaskbitrix()
          }
        },
        (err) => {
          this.loading = false
          this.show = false
          var error = err.body
          this.$message({
            type: 'error',
            message: error.message
          })
        }
      )
    },
    gettaskbitrix () {
      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            res.data.forEach(l => {
              var industryname = {}
              industryname.text = l.BRANCHE
              industryname.value = l.BRANCHE_ID
              this.prisenJoboption.push(industryname)
            })
          }
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    paginationChanged (currpage) {
      this.loading = true
      this.reviewsbitrix = []
      this.currentpage = currpage
      this.getreviewsBitrix(currpage)
    },
    reportreview (reviewdata) {
      var option = this.report
      this.isLoadingReview = true
      const fileList = this.fileList[0]
      this.haaId = localStorage.getItem('haaid')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var dataform = new FormData()
      dataform.append('DOCUMENTATIONCOMMENT', this.reportNote)
      dataform.append('TRADEMANCOMPLAINTHEADLINE', this.reportNote)
      dataform.append('TRADEMANCOMPLAINT', this.report)
      dataform.append('REVIEWID', reviewdata.ID)
      if (option === '3') {
        dataform.append('TRADEMANCOMPLAINTCATEGORY', Number(this.industryValue))
        dataform.append('file', fileList.raw)
      }
      this.$http.post(this.$bitrixapi + 'partner/rating/UploadReviewDocumentationv2', dataform, { headers }, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              $('html,body').animate({scrollTop: ($('#row-' + reviewdata.ID).offset().top - 270)}, 'slow')
              document.querySelector('.flag-link' + reviewdata.ID).classList.add('hide')
              document.querySelector('.report-form' + reviewdata.ID).classList.add('hide')
              this.clearFieldsReportForm()
              var message = ''
              if (option !== '3') {
                message = ''
              } else {
                message = 'Tak for din anmodning om at flytte din anbefaling til en anden kategori. Vi kontrollerer løbende for at undgå snyd ifm. Håndværker.dk Prisen - derfor kan der ske afvisninger. Hvis din anmodning afvises, modtager du en mail inden for 7 dage. '
              }
              let obj = {
                title: 'Rapport indsendt!',
                message: message,
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.isLoadingReview = false
              this.getreviewsBitrix(this.currentpage)
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          },
          response => {
            this.isLoadingReview = false
            this.loading = false
            var error = response.body
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        )
    },
    addeditcomment (item) {
      this.loading = true
      this.isLoadingReview = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.haaId = localStorage.getItem('haaid')
      var commentWithBreak = item.SupplierComment.replaceAll('\n', '\\n')
      var data = {
        SUPPLIERCOMMENT: commentWithBreak,
        Review_ID: item.id
      }
      this.$http.post(this.$bitrixapi + 'partner/EditSupplierComment', data, { headers }, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.isLoadingReview = false
            this.sampleReviewcs = ''
            item.SupplierCommentDate = 'Today'
            if (res.success) {
              this.getreviewsBitrix(this.currentpage)
              let obj = {
                title: 'Gennemført',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.hideModal()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          },
          response => {
            this.isLoadingReview = false
            this.loading = false
            var error = response.body
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        )
    },
    downloadreview (review, share) {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.show = true
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/rating/reviewImage/' + review.ID, { headers }, data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.success) {
              if (share === 1) {
                // https://widget.haandvaerker.dk/banners/Sharefbpngbitrix.php?id=151767
                // window.open('https://www.facebook.com/sharer/sharer.php?u=https://widget.haandvaerker.dk/banners/Sharefbpngbitrix.php?id=' + review.ID, '_blank')
                window.open('https://www.facebook.com/sharer/sharer.php?u=' + res.data.url, '_blank')
              } else {
                const linkSource = 'data:image/jpg;base64,' + encodeURI(res.data.base64)
                const downloadLink = document.createElement('a')
                const fileName = 'anbefaling' + review.ID + '.jpg'
                downloadLink.href = linkSource
                downloadLink.download = fileName
                downloadLink.click()
              }
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          },
          response => {
            var error = response.body
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        )
    },
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      if (localStorage.getItem('haaid') === '0') {
        this.loading = false
        return
      }
      var data = {operation: 'anbefalinger', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.reviews = res
            this.show = false
            this.loading = false
            var z = 0
            for (var id in this.reviews) {
              var review = this.reviews[id]
              var checkreview = this.moment(review.RatedDate, 'YYYY/MM/DD')
              var checkpremonth = this.moment(this.premonth, 'YYYY/MM/DD')
              var month1 = checkreview.format('M')
              var year1 = checkreview.format('YYYY')
              var month2 = checkpremonth.format('M')
              var year2 = checkpremonth.format('YYYY')
              if (month1 === month2 && year1 === year2) {
                z = z + 1
              }
            }
            this.$emit('UpdateAnb', z)
            this.isLoadingReview = false
            if (this.reviews.length === 0) {
              this.reviewslength = true
            }
            this.reviewcat()
          },
          response => {
            alert('error ')
          }
        )
    },
    selectIndustry (industry) {
      if (industry === null) return 'Ingen'
      for (var id in this.reviewscat) {
        var cat = this.reviewscat[id]
        if (cat.value === industry) {
          return cat.text
        }
      }
    },
    reviewcat () {
      this.reviewscat = []
      this.reviewscat.push({
        text: 'Vælg den fagkategori du vil ændre til',
        value: null,
        disabled: true
      })
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'anbefalingercat', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            for (var id in res) {
              var cat = res[id]
              this.reviewscat.push({
                text: cat.Title,
                value: cat.IndustryId
              })
            }
          },
          response => {
            alert('error')
          }
        )
    },
    review_service (item) {
      this.isLoadingReview = true
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var commentWithBreak = item.SupplierComment.replaceAll('\n', '\\n')
      var dataPartner = {operation: 'review_service', salesPerson: this.salesPerson, levid: this.haaId, item: item.ReviewId, note: commentWithBreak}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.isLoadingReview = false
            this.show = false
            this.sampleReviewcs = ''
            item.SupplierCommentDate = 'Today'
            if (res.success) {
              this.Reload()
              let obj = {
                title: 'Gennemført',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.hideModal()
            } else {
              console.log(response)
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    reviewcs_service_action (item) {
      this.isLoadingReview = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'reviewcs_service', salesPerson: this.salesPerson, levid: this.haaId, item: item.ReviewId, note: this.sampleReviewcs}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.isLoadingReview = false
            if (res.success) {
              alert('Gennemført!')
              this.hideModal()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    reviewcs_service () {
      this.reviewShow = false
      this.reviewShowcs = true
    },
    showItemDetailsold (review) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.show = true
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'anbefalingerDetail', salesPerson: this.salesPerson, levid: this.haaId, reviewId: review.ReviewId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.show = false
            this.reviewShow = !this.reviewShow
            review.SupplierComment = review.SupplierComment.replaceAll('\\n', '\n')
            this.sampleReview = review
            // Convert textarea \n to html
            if (this.reviewShow) {
              setTimeout(function () {
                // document.getElementById('textarea1').value = review.SupplierRatingComment.replaceAll('\\n', '\n')
              }, 5000)
            }
            this.sampleReview.time = parseFloat(res.ContactRating)
            this.sampleReview.listen = parseFloat(res.AgreementRating)
            this.sampleReview.bargain = parseFloat(res.PriceRating)
            this.sampleReview.clean = parseFloat(res.CleaningRating)
            this.sampleReview.quality = parseFloat(res.WorkRating)
            this.sampleReview.recommend = parseFloat(res.RecommendRating)
            this.sampleReview.total = parseFloat(res.Rating)
            this.sampleReview.RequesterName = res.RequesterName
            this.sampleReview.RequesterComment = res.RequesterComment
            this.sampleReview.Title = res.Title
          },
          response => {
            alert('error')
          }
        )
    },
    showItemDetails (review) {
      this.sampleReview = {}
      this.sampleReview.time = parseFloat(review.CONTACT_RATING)
      this.sampleReview.listen = parseFloat(review.AGREEMENT_RATING)
      this.sampleReview.bargain = parseFloat(review.PRICE_RATING)
      this.sampleReview.clean = parseFloat(review.CLEANING_RATING)
      this.sampleReview.quality = parseFloat(review.WORK_RATING)
      this.sampleReview.recommend = parseFloat(review.RECOMMEND_RATING)
      this.sampleReview.total = parseFloat(review.RATING)
      this.sampleReview.RequesterName = review.CONTACT.NAME
      this.sampleReview.SupplierComment = review.COMMENT
      this.sampleReview.RequesterComment = review.DESCRIPTION.replaceAll('\\n', '\n')
      this.sampleReview.Title = review.TITLE
      this.sampleReview.id = review.ID
      this.reviewShow = true
    },
    forceFileDownload (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.png')
      document.body.appendChild(link)
      link.click()
    },
    downloadItemDetails (review, share) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      this.show = true
      var data = {operation: 'anbefalingerDownload', salesPerson: this.salesPerson, levid: this.haaId, reviewId: review.ReviewId, reviewPic: review.ProfilePicPath}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              if (share === 1) {
                window.open('https://www.facebook.com/sharer/sharer.php?u=https://www.håndværker.dk/microsites/rating.php?id=' + review.ReviewId, '_blank')
              } else {
                const linkSource = 'data:image/jpg;base64,' + encodeURI(res.url)
                const downloadLink = document.createElement('a')
                const fileName = 'anbefaling' + review.ReviewId + '.jpg'
                downloadLink.href = linkSource
                downloadLink.download = fileName
                downloadLink.click()
              }
            } else {
              alert('error')
            }
          },
          response => {
            alert('error')
          }
        )
    },
    hideModal () {
      this.reviewShow = false
      this.reviewShowcs = false
    },
    setRating (rating) {
      this.sampleReview.rating = rating
    },
    showReportForm (reviewId) {
      this.clearFieldsReportForm()
      this.openreportid = reviewId
      var reportForm = document.querySelector('.report-form' + reviewId)
      if (reportForm.classList.contains('hide')) {
        reportForm.classList.remove('hide')
      } else {
        reportForm.classList.add('hide')
      }
      this.reviewsbitrix.forEach(e => {
        if (e.ID !== Number(reviewId)) {
          setTimeout(() => {
            if (!document.querySelector('.report-form' + e.ID.toString()).classList.contains('hide')) {
              document.querySelector('.report-form' + e.ID.toString()).classList.add('hide')
            }
          }, 100)
        }
      })
    },
    reportOptionsChanged (review) {
      var datenow = new Date(review.CREATED_ON_SHOW)
      var prisenstart = new Date('2022-08-16')
      var prisenend = new Date('2023-08-15')
      if (datenow.getTime() >= prisenstart.getTime() && datenow.getTime() <= prisenend.getTime()) {
        this.endprisenpopup = true
        return false
      } else {
        const option = this.report
        if (option === '3') {
          this.fileUploadVisible = true
          setTimeout(function () {
            var fileUploadText = document.querySelectorAll('.report-form button > span:nth-child(2)')
            for (var i = 0; i < fileUploadText.length; i++) {
              fileUploadText[i].innerText = 'Indsend dokumentation for opgavens reelle fagkategori'
            }
          }, 100)
        } else {
          this.fileUploadVisible = false
        }
      }
    },
    handleFileUpload (file, fileList) {
      this.fileList = fileList
    },
    checkBeforeSubmit (reviewdata) {
      var datenow = new Date(reviewdata.CREATED_ON_SHOW)
      var prisenstart = new Date('2022-08-16')
      var prisenend = new Date('2023-08-15')
      if (datenow.getTime() >= prisenstart.getTime() && datenow.getTime() <= prisenend.getTime()) {
        this.endprisenpopup = true
        return false
      } else {
        const option = this.report
        const fileList = this.fileList
        const note = this.reportNote
        const industryValue = this.industryValue
        if (option !== '3') {
          if (option !== null && note !== '') {
            this.reportreview(reviewdata)
          } else {
            this.$toastr('error', 'Felter påkrævet')
          }
        } else {
          var uploadFinish = localStorage.getItem('uploadFinish')
          if (uploadFinish === true || uploadFinish === null) {
            if (option !== null && note !== '' && fileList && industryValue !== null) {
              this.reportreview(reviewdata)
            } else {
              if (fileList.length === 0) {
                this.$toastr('error', 'Indsend dokumentation for opgavens reelle fagkategori')
              } else {
                this.$toastr('error', 'Felter påkrævet')
              }
            }
          } else {
            this.$toastr('error', 'Uploader stadig')
          }
        }
      }
    },
    submitReport (id) {
      this.isLoadingReview = true
      const reviewId = id
      const option = this.report
      const industryValue = this.industryValue
      const fileList = this.fileList
      const note = this.reportNote
      const salesPerson = localStorage.getItem('id_token_portal')
      var files = []
      if (fileList.length > 0) {
        for (var i = 0; i < fileList.length; i++) {
          files.push('https://www.kundematch.dk/HenttilbudImg.php?img=' + fileList[i])
        }
      }
      var data = {
        operation: 'addreport',
        salesPerson: salesPerson,
        review_id: reviewId,
        option: option,
        industryValue: industryValue,
        files: JSON.stringify(files),
        note: note
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              $('html,body').animate({scrollTop: ($('#row-' + reviewId).offset().top - 270)}, 'slow')
              document.querySelector('.flag-link' + id).classList.add('hide')
              document.querySelector('.report-form' + id).classList.add('hide')
              this.clearFieldsReportForm()
              var message = ''
              if (option !== '3') {
                message = ''
              } else {
                message = 'Tak for din anmodning om at flytte din anbefaling til en anden kategori. Vi kontrollerer løbende for at undgå snyd ifm. Håndværker.dk Prisen - derfor kan der ske afvisninger. Hvis din anmodning afvises, modtager du en mail inden for 7 dage. '
              }
              let obj = {
                title: 'Rapport indsendt!',
                message: message,
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Reload()
              this.isLoadingReview = false
            } else {
              this.isLoadingReview = false
              this.show = false
              alert('Error')
            }
          },
          response => {
            this.isLoadingReview = false
            console.log('Error in submitReport()')
          }
        )
    },
    clearFieldsReportForm () {
      this.report = null
      this.reportNote = ''
      this.fileList = []
      this.fileUploadVisible = false
    }
  }
}
</script>
<style>
#Reviewspage .el-upload {
  width: 100%;
}
#Reviewspage .modal-header,
.modal-footer,
.card-header {
  border-top: 0;
  border-bottom: 0;
  background: none;
  padding-bottom: 0;
}
#Reviewspage .vue-star-rating-rating-text {
  display: none;
}
#Reviewspage a.flag:after {
  display: none;
}
/*Blur review*/
.under_investigation:after,
.reported_for_deletion:after,
.deletion_review_pending:after,
.trademan_complaints:after {
  content: "Under kvalitetssikring";
  font-size: 2rem;
  font-weight: 600;
  color: #8a8a8a;
  text-align: center;
  position: relative;
  display: block;
  bottom: 60%;
  align-items: center;
  height: 0;
}
.under_investigation, .reported_for_deletion, .deletion_review_pending, .trademan_complaints .blur-part {
  filter: blur(5px);
  pointer-events: none;
}
@media (max-width: 52em) {
  .under_investigation:after {
    bottom: 14.5rem;
  }
}
#Reviewspage .report-facebook-button {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 0.5px solid #D8000F;
  color: #D8000F;
}
.buttonanbefal {
  /* width: 330px; */
  height: 55px;
}
.outlined-facebook-button {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 0.5px solid #2079FF;
  color: #2079FF;
}
.outlined-dark-button {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 0.5px solid #003645;
}
#Reviewspage .loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
#Reviewspage .loader {
  color: #003645 !important;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#Reviewspage .loader:before,
#Reviewspage .loader:after {
  position: absolute;
  content: '';
}
#Reviewspage .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#Reviewspage .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
textarea[placeholder]:focus::-webkit-input-placeholder {
  transition: opacity 0.5s 0.5s ease;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Reviews.vue?78a65a78